import { MapPoint, MapTrack } from '@/objects/generated';

/**
 * Add additional properties to the MapTrack class for front-end use.
 */
export class MapTrackData {
    public MapTrack: MapTrack;

    public Opacity: number = 1;

    public Key: number | null = null;

    public constructor(track?: MapTrack) {
        if (track) {
            this.MapTrack = track;
        } else {
            this.MapTrack = MapTrack.FromJsValues({
                EntityState: 'Added',
                Points: [],
            });
        }

        this.Opacity = 1;
    }
}
